import infoIcon from "@/assets/pos/info.svg";
import type { ReactNode } from "react";

interface NoRecordFoundProps {
  title: string;
  description?: string;
  iconSrc?: string;
  action?: ReactNode;
}

export default function NoRecordFound({
  title,
  description,
  iconSrc = infoIcon,
  action,
}: NoRecordFoundProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center gap-2">
      <img src={iconSrc} alt="no data" className="mb-2" />

      <p className="text-[20px] leading-[30px] font-bold text-[var(--primary-text-color)]">
        No {title} Found
      </p>

      {description && (
        <p className="text-sm leading-[22px] text-[var(--secondary-text-color)] max-w-md">
          {description}
        </p>
      )}

      {action && <div className="mt-4 bg-transparent">{action}</div>}
    </div>
  );
}
